import ListLayoutService from "../../services/layout-services/ListLayoutService";

const ListLayoutHandler = {
  mixins: [ListLayoutService],
  template: `<div><slot></slot></div>`,
};

export default ListLayoutHandler;
